import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';

import { CardPlanWrapper } from './Wrapper';

type PlanCardProps = {
  plan: string;
  periodName: string;
  description?: string;
};

const CardPlan: FC<PlanCardProps> = ({
  plan,
  periodName,
  description,
  children
}) => (
  <CardPlanWrapper>
    <TitleBlock
      title={`${plan}  ${periodName}`}
      description={description}
      size={'medium-thin'}
    />
    {children}
  </CardPlanWrapper>
);

export default CardPlan;
